export default __webpack_public_path__ + "static/media/strikepay_Mark_poweredby_RGB_Black.3bfa943e.png";